export default [
  {
    no: '1',
    path: 'microbeads',
    name: 'Microbeads',
    whatAreThey:
      'Microplastic particles less than 5mm in diameter that do not degrade or dissolve in water. Microbeads, as they are called in rinse-off products, are used for cleaning and exfoliating purposes.',
    whereFrom:
      'Synthetic plastic particles manufactured in different shapes and sizes.',
    risks:
      'There is concern regarding the potential damaging effect of microbeads on aquatic life due to composition and shape, as well as the potential transfer to humans through the food chain. These microbeads remain in the environment as they are almost impossible to remove  with existing technology. \nIn December 2015, a regulation to reduce the amount of microbeads reaching waterways was established in the US, and microbeads in cosmetic rinse-off products have been banned in most countries. \nMicrobeads from cosmetics account for less than 2% of plastic pollution in the marine environment, and their long-term environmental effect is still being studied.',
    whyAndHow:
      'We have not used microbeads in rinse-off products since 2018, and we carefully follow advancements in microplastic research and regulations in order to prepare for agile action.',
    related: ['6', '4', '16'],
    metaTitle: 'Microbeads',
    metaKeywords: 'Microbeads',
    metaDescription:
      'Microbeads are used for cleaning and exfoliating purposes in rinse-off products, and achieve a comfortable feeling in leave-on products.',
  },
  {
    no: '2',
    path: 'oxybenzone',
    name: 'Oxybenzone',
    whatAreThey:
      'A synthetic compound that belongs to a group of chemicals known as benzophenones. It is widely used in household products, sunglasses, food packaging, etc. In cosmetics, it absorbs UV radiation, protecting skin and the cosmetics product itself.',
    whereFrom:
      'It is a naturally occurring chemical found in various flowering plants; however, the oxybenzone used in the cosmetics industry is of synthetic origin.',
    risks:
      'WHO defines oxybenzone as not an endocrine disruptor that affects growth and immune function.\nOn the other hand, Oxybenzone is suspected to be a potential endocrine disruptor in Europe, and the European Commission is conducting further safety investigations to decide its status as a permitted cosmetics ingredient.\nThe state of Hawaii prohibited sales of primary sunscreen products incorporating oxybenzone in July 2018 and Palau and Thai National Park ban the use of sunscreen containing oxybenzone for leisure purpose, due to its concerns around coral bleaching.',
    whyAndHow:
      'We are developing and reformulating our products to remove oxybenzone in line with country regulations and our own safety criteria.',
    related: ['6', '4', '16'],
    metaTitle: 'Oxybenzone',
    metaKeywords: 'Oxybenzone',
    metaDescription:
      'In cosmetics, Oxybenzon absorbs UV radiation, protecting the skin and the cosmetics products.',
  },
  {
    no: '3',
    path: 'octocrylene',
    name: 'Octocrylene',
    whatAreThey:
      'A synthetic compound used in sunscreens to protect the skin against the damaging effects of UV radiation.',
    whereFrom: 'It is a chemically synthesized ingredient.',
    risks:
      'WHO defines octocrylene as not an endocrine disruptor that affects growth and immune function.\nOctocrylene has been studied for a long time in Europe, but it was concluded in 2021 that there is no endocrine disruptor action in the range of the concentration where UV formulation is permitted.\nResearchers are discussing the effects on corals in the ocean. As of 2021, octocrylene is a permitted sunscreen ingredient in Hawaii, and is banned the use of sunscreens including octocrylene in Palau and the Virgin Islands (US).',
    whyAndHow:
      'We use octocrylene following our internal safety criteria and in line with cosmetic regulations in each country.\nWe are assessing the impact on coral by combining joint research with University lab who are working on research related to reef-building corals and coral reef organisms, with advanced simulation on ocean concentration. We are also developing formulas for minimizing effect on corals when octocrylene is used in the sunscreen for marine use.\nWe pay close attention to regulatory and research on environmental impact in each country and take agile action.',
    related: ['6', '4', '16'],
    metaTitle: 'Octocrylene',
    metaKeywords: 'Octocrylene',
    metaDescription:
      'Octocrylene is a synthetic compound used in sunscreens to protect the skin against the damaging effect of UV radiation.',
  },
  {
    no: '4',
    path: 'cyclosiloxanes',
    name: 'Cyclosiloxanes',
    whatAreThey:
      'Basic members of the broad family of silicone materials, all cyclotetrasiloxane (D4), cyclopentasiloxane (D5), cyclohexasiloxane (D6) are volatile oils with a cyclic chemical structure and various properties. They are  widely used because of the smooth and refreshing feeling they create.',
    whereFrom: 'They are chemically synthesized from silica stones.',
    risks:
      'D4, D5 and D6 are persistent in the environment, although their long term effects are not known. D4 and D5 are not permitted in rinse-off cosmetic products in a concentration equal to or greater than 0.1% in the EU. D6 is currently being reviewed.\nD4 has been listed as a potential reproductive toxic substance in Europe.',
    whyAndHow:
      'We do not use cyclosiloxanes in rinse-off products such as shampoos and conditioners in response to environmental concerns.\nWe have stopped using D4 since it is suspected of having reproductive toxic effects.\nWe use D5 and D6 for leave-on products, carefully following EU regulations and updates.',
    related: ['6', '4', '16'],
    metaTitle: 'Cyclosiloxanes（D4, D5, D6)',
    metaKeywords: 'Cyclosiloxanes（D4, D5, D6)',
    metaDescription:
      'Cyclosiloxanes have wide applications such as emollients, humectant, solvent, viscosity control and hair conditioning.',
  },
  {
    no: '5',
    path: 'silicones',
    name: 'Silicones',
    whatAreThey:
      'Inert synthetic polymers with various chemical structures that provide a smooth feeling and have a wide range of applications, such as emollients, humectants, solvents, viscosity controllers and hair conditioners.',
    whereFrom: 'They are chemically synthesized from silica stones.',
    risks:
      'Silicones are accused of causing skin congestion, clogging pores and dehydrating the skin. Some are not easily biodegradable and may be persistent in the environment. But in general, scientific evidence does not suggest that products containing silicones have a significant negative impact on skin or the environment.',
    whyAndHow:
      'We use high-quality silicones with a minimal environmental impact.',
    related: ['6', '4', '16'],
    metaTitle: 'Silicones',
    metaKeywords: 'Silicones',
    metaDescription:
      'Silicones provide a smooth feeling and have wide applications such as emollients, humectants, and hair conditioning.',
  },
  {
    no: '6',
    path: 'parabens',
    name: 'Parabens',
    whatAreThey:
      'A family of preservatives used by the food, pharmaceutical and cosmetics industries to prevent microbial contamination that could potentially threaten product safety and quality.',
    whereFrom:
      'Parabens occur naturally in red fruit, carrots and royal jelly, but when used commercially are of synthetic origin.',
    risks:
      'Parabens are suspected to be endocrine disruptors and can potentially induce cancer. Therefore, the European Commission has set up limits to the use of parabens in cosmetics that guarantees its safety. \nThe endocrine disruption activity increases with the length of the paraben: long chain parabens (ex. butylparaben and propylparaben) have stronger disruption activity, whereas short chain parabens (ethylparaben and methylparaben) present very low activity and are considered safer. For example, in all cases it is not reported to increase the risk of breast cancer when used at regulated concentrations.',
    whyAndHow:
      'We use ethylparaben and methylparaben at lower concentrations than those set up by regulatory bodies, following our safety criteria. \nWe have been developing and reformulating our products without butylparaben and propylparaben.',
    related: ['6', '4', '16'],
    metaTitle: 'Parabens',
    metaKeywords: 'Parabens',
    metaDescription:
      'Parabens are a family of preservatives used by the food, pharmaceutical and cosmetics industries.',
  },
  {
    no: '7',
    path: 'mit-mci',
    name: 'MIT/MCI',
    subtitle: 'Methylisothiazolinone / Methylchloroisothiazolinone',
    whatAreThey:
      'A mixture of two chemically similar preservatives found in many personal care products. Is is used to control microbial growth in water-containing solutions to avoid discoloration, unpleasant odors or product breakdown.',
    whereFrom: 'It is a chemically synthesized ingredient.',
    risks:
      'MIT and MCI have been associated with allergic reactions and eczema. The risk of allergy of MIT was confirmed in leave-on products, and as such, the European Commission prohibited the use of MIT in leave-on products in February 2017. \nPermitted concentration of MCI is considered safe.',
    whyAndHow:
      'We prohibited the inclusion of MIT/MCI in any product according to our safety criteria. ',
    related: ['6', '4', '16'],
    metaTitle: 'MIT/MCI',
    metaKeywords: 'MIT,Methylisothiazolinone,MCI,Methylchloroisothiazolinone',
    metaDescription:
      'MIT/MCI is a mixture of two chemically similar preservatives found in many personal care products.',
  },
  {
    no: '8',
    path: 'phenoxyethanol',
    name: 'Phenoxyethanol',
    whatAreThey:
      'A commonly used preservative in water-containing products due to its ability to inhibit fungi, bacteria and yeast growth.',
    whereFrom:
      'It can be found naturally in green tea, but when used commercially is of synthetic origin.',
    risks:
      'Phenoxyethanol is suspected to be an endocrine disruptor and toxic to the liver. However, it is not considered as a potential endocrine disruptor by the Endocrine Disruption Exchange (TEDX). \nSome limited studies have shown skin irritation and allergic reaction of phenoxyethanol on the nappy area for babies, and the European Cosmetics Regulation has set a safe maximum concentration limit of 1%.',
    whyAndHow:
      'We use phenoxyethanol well below the permitted concentration in most of our products, as per our safety criteria and following cosmetic regulations in each country.',
    related: ['6', '4', '16'],
    metaTitle: 'Phenoxyethanol',
    metaKeywords: 'Phenoxyethanol',
    metaDescription:
      'Phenoxyethanol is used preservative in water-containing products due its property to inhibit fungi, bacteria and yeast growth.',
  },
  {
    no: '9',
    path: 'bht',
    name: 'BHT',
    subtitle: 'Butylated hydroxytoluene',
    whatAreThey:
      'Stabilizer used in many personal care products and foods. Acts as antioxidant by maintaining the stability of oil, fats and active ingredients such as vitamins.',
    whereFrom:
      'It is present in lychee fruit, but when used commercially is of synthetic origin.',
    risks:
      'Some studies suggest that BHT could be an endocrine disruptor and the European Commission included BHT in an endocrine disruptor priority list to gain more scientific data for future assessment. Currently, it is permitted under European regulation at any level.',
    whyAndHow:
      'We use BHT in both leave-on and rinse-off products, at a concentration below 0.1% according to our safety criteria and following cosmetic regulations by each country.',
    related: ['6', '4', '16'],
    metaTitle: 'Butylated hydroxytoluene (BHT)',
    metaKeywords: 'Butylated hydroxytoluene,BHT',
    metaDescription:
      'BHT act as antioxidant by maintaining the stability of oil, fats and active ingredients such as vitamins.',
  },
  {
    no: '10',
    path: 'bha',
    name: 'BHA',
    subtitle: 'Butylated hydroxyanisole',
    whatAreThey:
      'A stabilizer used in many personal care products and foods. Acts as an antioxidant by maintaining the stability of oil, fats and active ingredients such as vitamins.',
    whereFrom: 'It is a chemically synthesized ingredient.',
    risks:
      "BHA is associated with reproductive dysfunction, increased cancer risk – including breast and prostate – and a range of other chronic or irreversible health problems.\nThe European Commission included BHA in an endocrine disruptor priority list to gain more scientific data for future assessment. \nIt is listed as a known carcinogen under California's Proposition 65.",
    whyAndHow: 'We do not use BHA due to our safety criteria.',
    related: ['6', '4', '16'],
    metaTitle: 'Butylated hydroxyanisole (BHA)',
    metaKeywords: 'Butylated hydroxyanisole,BHA',
    metaDescription:
      'BHA act as antioxidant by maintaining the stability of oil, fats and active ingredients such as vitamins.',
  },
  {
    no: '11',
    path: 'triclosan',
    name: 'Triclosan',
    whatAreThey:
      'A widely used preservative since 1957 due to its antimicrobial properties. It is mostly found in personal care products as well as clothing, carpets, plastics, toys and more.',
    whereFrom: 'It is a chemically synthesized ingredient.',
    risks:
      'Triclosan is suspected to be an endocrine disruptor and impacts thyroid function and thyroid homeostasis. \nGrowing evidence suggests a link between the use of triclosan and the increase of bacteria that are resistant to antibiotics.\nThe FDA in September 2016 banned the use of triclosan on antiseptic OTC wash products because of the insufficient antiseptic effect.',
    whyAndHow: 'We do not use triclosan due to our safety criteria.',
    related: ['6', '4', '16'],
    metaTitle: 'Triclosan',
    metaKeywords: 'Triclosan',
    metaDescription:
      'Tricrosan is widely used preservative since 1957 for its antimicrobial properties.',
  },
  {
    no: '12',
    path: 'nano-particles',
    name: 'Nano particles',
    subtitle: 'Titanium dioxide, Zinc oxide',
    whatAreThey:
      'Particles with at least one dimension between 1 and 100 nanometers, which are too small to be seen with the naked eye or conventional microscopes.\nSince they do not reflect visible light, nano-sized titanium dioxide and zinc oxide particles are used in sunscreens to scatter UV rays without causing a white coating.',
    whereFrom:
      'Nanoparticles are occasionally produced in nature or can be engineered for commercial purposes.',
    risks:
      "A common concern is that nanoparticles could penetrate the skin and end up in internal organs or the bloodstream – and that they may be toxic. The European Commission found that nanomaterials do not penetrate into healthy skin and are therefore considered safe. However, the safety of particles inhaled from powder or aerosol products has not been verified. \nNanomaterials are permitted worldwide. In some countries and regions including Europe, the word 'nano' must follow the name of the substance in ingredient listings (in parenthesis).",
    whyAndHow:
      'We use titanium dioxide and zinc oxide nanoparticles in sunscreen products due to their highly performing properties. We have evaluated that they do not penetrate the skin, and since they are generally suspended in wet formulas (emulsions, solutions, etc.), the risk of inhaling them is low. Furthermore, we have assessed that the potential amount that could be inhaled does not represent a risk to human health.',
    related: ['6', '4', '16'],
    metaTitle: 'Nano particles (ZnO, TiO2)',
    metaKeywords: 'Nano particles,ZnO,TiO2,Zinc oxide,Titanium dioxide',
    metaDescription:
      'Nano particles is with at least one dimension between 1 and 100 nanometers. ZnO and TiO2 are used in sunscreens to absorb UV.',
  },
  {
    no: '13',
    path: 'sulfates',
    name: 'Sulfates',
    subtitle:
      'Sodium lauryl sulfate, Sodium laureth sulfate, Ammonium lauryl sulfate',
    whatAreThey:
      'Sulfates are detergents and surfactants that produce foam, and can clean the skin and hair by helping water to mix with oil and dirt so that they can be rinsed away.',
    whereFrom:
      'Sulfates are produced chemically from palm kernel oil or coconut oil.',
    risks:
      'Sulfates are presumed to cause skin irritation, dryness and cancer, however, they are not included in any list of carcinogenic materials from authorities such as WHO, IARC, and the EU. There is also no clear scientific evidence about the carcinogenicity of these ingredients.\nWhile certain studies have shown a mild level of skin irritation, safety has been verified when used in rinse-off products. ',
    whyAndHow:
      'We use sulfates mainly for rinse-off products,　which guarantees minimal exposure and does not cause scalp or skin irritation. When used to ensure the quality and effectiveness of certain ingredients, we use them in very low concentrations.',
    related: ['6', '4', '16'],
    metaTitle: 'Sulfates',
    metaKeywords:
      'Sulfates,Sodium Lauryl Sulfate,Sodium Laureth Sulfate,Ammonium Lauryl Sulfate,SLS,SLES,ALS',
    metaDescription:
      'Sulfates are detergent and surfactants, and can clean the skin and hair by helping water to mix with oil and dirt.',
  },
  {
    no: '14',
    path: 'petrolatum',
    name: 'Petrolatum',
    whatAreThey:
      'An odorless and colorless jelly-like substance that has been used as a moisturizing agent since 1859.',
    whereFrom: 'Petrolatum is refined from petroleum.',
    risks:
      'There is a concern that petrolatum contains impurities such as polycyclic aromatic hydrocarbons (PAHs) that are carcinogenic; however, highly purified petrolatum (pharmaceutical and cosmetic grade) does not contain PAHs and is considered safe worldwide – to the point that it is commonly used as dermatological medication to treat minor skin irritations.',
    whyAndHow:
      'We use highly purified cosmetic/pharmaceutical grade petrolatum that does not contain impurities harmful to humans according to our safety criteria.',
    related: ['6', '4', '16'],
    metaTitle: 'Petrolatum',
    metaKeywords: 'Petrolatum',
    metaDescription:
      'Petrolatum is an odorless and colorless jelly like substance that has been used as a moisturizing agent since 1859.',
  },
  {
    no: '15',
    path: 'palm-oil',
    name: 'Palm oil',
    whatAreThey:
      'An edible odorless and colorless vegetable oil. It is widely used to produce cosmetic ingredients such as glycerin and other fatty acid derivatives. Glycerin is an emollient with moisturizing effects.',
    whereFrom:
      'There are two grades of oil obtained from the palm tree: elaeis guineensis, which is a crude palm oil squeezed from the palm fruit; and palm kernel oil, which comes from crushing the kernels.',
    risks:
      'Palm oil cultivation has caused deforestation in some of the world’s most biodiverse forests in Indonesia and Malaysia. Burning carbon rich peat soils to clear land has released greenhouse gases into the atmosphere, contributing to climate change. Likewise, some palm oil plantations frequently violate workers’ rights and use child labor.\nThe Roundtable of Sustainable Palm Oil (RSPO) was formed in 2004 and sets and audits best farming practices under environmental and social principles.\nOnly RSPO-certified palm oil guarantees that it has not been grown on cleared land, is produced sustainably, and smallholder conditions are fair.',
    whyAndHow:
      'We joined the RSPO in 2010 and have since supported the production of certified sustainable palm oil. We committed with the total amount of palm oil derivatives that we use, and strive for sustainable procurement.',
    related: ['6', '4', '16'],
    metaTitle: 'Palm oil',
    metaKeywords: 'Palm oil',
    metaDescription:
      'Palm oil is a vegetable oil widely used to produce cosmetics ingredients such as glycerin and other fatty acids derivatives.',
  },
  {
    no: '16',
    path: 'mica',
    name: 'Mica',
    whatAreThey:
      'A naturally occurring mineral ingredient used to provide a sparkling appearance in makeup products.',
    whereFrom:
      'Mica is a group of silicate minerals that are present in different types of rocks used by humans since prehistoric times.\nIt also can be chemically synthesized. ',
    risks:
      'In India, mica mainly originates from socially and economically challenged regions where there is a risk of child labor, unsafe working conditions, and where the supply chain involves multiple players – making it difficult to thoroughly assess. \nThe Responsible Mica Initiative is a non-governmental organization created in January 2017 to build a sustainable mica supply chain in India by promoting responsible sourcing practices and eradicating child labor and unacceptable working condition. \nAs mica comes from the earth, it may contain trace amounts of heavy metals.',
    whyAndHow:
      'We joined the Responsible Mica Initiative and have been taking action on improving sustainable procurement.\nWe can verify that heavy metal content is within safe and regulatory limits, and we also use synthetic mica, which contains less heavy metals and has less social concerns.',
    related: ['6', '4', '16'],
    metaTitle: 'Mica',
    metaKeywords: 'Mica',
    metaDescription:
      'Mica is naturally occurring mineral ingredient used to provide a sparkling white appearance on makeup products.',
  },
  {
    no: '17',
    path: 'essential-oils',
    name: 'Essential oils',
    whatAreThey:
      'Essential oils are extracted from plants and used for their many active properties and characteristic scents.',
    whereFrom:
      'Essential oils can be extracted from different parts of plants.',
    risks:
      'Essential oils may contain allergens that can trigger skin  allergies. The International Fragrance Association (IFRA) has established maximum recommended limits for essential oils to minimize contact allergies. The European Commission has made it mandatory to indicate on the label if the product contains one of the 26 substances identified as highly allergenic. In general, allergic reactions to cosmetics containing essential oils at the recommended doses are rare.',
    whyAndHow:
      'We use essential oils following our own safety standards, which limit their concentration to the lowest levels among IFRA recommendations and country regulations, thus minimizing the risk of sensitization. \nFor products sold in Europe, we list the name of allergens in the ingredients.',
    related: ['6', '4', '16'],
    metaTitle: 'Essential oils',
    metaKeywords: 'Essential oils',
    metaDescription:
      'Essential oils are extracted from plants due their many natural active properties and characteristic scents.',
  },
  {
    no: '18',
    path: 'synthetic-fragrances',
    name: 'Synthetic Fragrances',
    whatAreThey:
      'Synthetic fragrances are used to recreate natural scents in a more affordable and less resource-intensive way, or to provide unique scents.',
    whereFrom:
      'Synthetic fragrances are a mix of chemically synthesized ingredients that produce a desired scent, with other chemicals such as solvents (ethanol), stabilizers, UV-absorbers, preservatives, dyes, etc.',
    risks:
      "Consumers are concerned that when they see the word 'fragrance' on the label, there is a possibility that synthetic chemicals linked to safety issues are present since fragrance chemicals are not disclosed. The International Fragrance Association (IFRA) has established maximum recommended limits for synthetic fragrance ingredients to minimize the risk of safety issues. \nThe European Commission has made it mandatory to indicate on the label if the product contains one of the 26 substances identified as highly allergenic. In general, allergic reactions to cosmetics containing synthetic fragrances at the recommended doses are rare.",
    whyAndHow:
      'We use synthetic fragrances following our own safety standards, which limit their concentration to the lowest levels among IFRA recommendations and country regulations, thus minimizing the risk of sensitization. \nFor products sold in Europe, we list the name of allergens in the ingredients.',
    related: ['6', '4', '16'],
    metaTitle: 'Synthetic Fragrances',
    metaKeywords: 'Synthetic Fragrances',
    metaDescription:
      'Synthetic fragrances are used to recreate natural scents on a more affordable, or to provide unique scents.',
  },
  {
    no: '21',
    path: 'impurities',
    name: 'Impurities',
    subtitle:
      'Acrylamide, Asbestos, Diethanolamine, 1,4-dioxane, Formaldehyde, Heavy metals',
    whatAreThey:
      'Impurities are very low or trace levels of undesired contaminants present in certain ingredients.',
    whereFrom:
      'They can occur naturally in the ingredient, or as a residue during chemical reactions used to create certain ingredients.',
    risks:
      'Synthetic ingredients have undergone purification processes and are supplied relatively free of impurities, although some impurities may exist as chemical reaction by-products (1,4-dioxane, Diethanolamine), remained monomar (Acrylamide), or when reacting with other chemicals (formaldehyde).\nIngredients derived from natural sources show different levels of impurities (heavy metals, asbestos), which makes it important to choose the sources and monitor for impurities continually.\n\n- 1,4-Dioxane: considered to be a known carcinogen.\n- Diethanolamine (DEA): considered to be a known carcinogen. \n- Acrylamide: considered to be a known carcinogen.\n- Formaldehyde: a known carcinogen that can cause allergic skin reactions and rashes. \n- Heavy metals: can be present in natural minerals and can be toxic depending on the type.\n- Asbestos: a known carcinogen that can be present in talc.',
    whyAndHow:
      'We have a strict selection process for the quality of our raw materials so that impurity concentrations are as low as possible in order to eliminate safety concerns.\nThe safety of our cosmetics is secured, taking into consideration their ingredients and unavoidable impurities/trace contents, as per our safety criteria — which is continuously updated and upgraded.',
    related: ['6', '4', '16'],
    metaTitle: 'Impurities',
    metaKeywords: 'Impurities,Acrylamide,Formaldehyde,DEA,1.4-dioxane,Asbestos',
    metaDescription:
      'Impurities refers to very low or "trace" levels of undesired contaminants present in certain ingredients.',
  },
  {
    no: '19',
    path: 'coal-tar',
    name: 'Coal Tar',
    whatAreThey:
      'Coal tar is a viscous, dark liquid derived from coal and used in skincare and haircare products for the treatment of dandruff, seborrheic dermatitis and psoriasis.',
    whereFrom: 'Generated from the incomplete combustion of coal.',
    risks:
      'It is considered a known carcinogen that can cause skin irritation, sun sensitivity and allergic reactions.\nThe International Agency for Research on Cancer lists coal tars as Group 1 carcinogens, meaning they are carcinogenic for humans.',
    whyAndHow: 'We do not use coal tar due to our safety criteria.',
    related: ['6', '4', '16'],
    metaTitle: 'Coal Tar',
    metaKeywords: 'Coal Tar',
    metaDescription: 'Coal Tar is a viscous dark liquid derived from coal.',
  },
  {
    no: '20',
    path: 'phthalates',
    name: 'Phthalates',
    whatAreThey:
      'A group of chemicals used in a variety of plastic products to make them more flexible. Phthalates are used in nail polishes to reduce cracking, in hair sprays to avoid stiffness, and in fragrances as a solvent and fixative.',
    whereFrom: 'Phthalates are chemically synthetized ingredients.',
    risks:
      'Phthalates are strongly suspected to be endocrine disruptors that cause developmental and reproductive toxicity. They have been banned from cosmetics in the European Union.',
    whyAndHow:
      'We do not use phthalates in our formulas due to our safety criteria.\nWe strictly select the materials used in our packaging to avoid phthalate contamination of our formulas.',
    related: ['6', '4', '16'],
    metaTitle: 'Phthalates',
    metaKeywords: 'Phthalates',
    metaDescription:
      'Phthalates are a group of chemicals used in a variety of plastic products to make them more flexible.',
  },
  {
    no: '22',
    path: 'octinoxate',
    name: 'Octinoxate',
    whatAreThey:
      'A synthetic compound used in sunscreens to protect the skin against the damaging effects of UV radiation.',
    whereFrom: 'It is a chemically synthesized ingredient.',
    risks:
      'WHO defines octinoxate as not an endocrine disruptor that affects development and immune functions.\nOn the other hand, octinoxate is suspected to be a potential endocrine disruptor in Europe, and the European Commission is conducting further safety investigations to decide its status as a permitted cosmetics ingredient.\nIn addition, researchers are discussing the effects on corals in the ocean. As of 2021, the state of Hawaii, Palau and Thai National Park ban the use of sunscreens including octinoxate for leisure purpose.',
    whyAndHow:
      'We use octinoxate following our internal safety criteria and in line with cosmetic regulations in each country.\nWe are assessing the impact on coral by combining joint research with University lab who are working on research related to reef-building corals and coral reef organisms, with advanced simulation on ocean concentration. We are also developing formulas for minimizing effect on corals when octinoxate is used in the sunscreen for marine use.\nWe pay close attention to regulatory and research on environmental impact in each country and take agile action.',
    related: ['6', '4', '16'],
    metaTitle: 'Octinoxate',
    metaKeywords: 'Octinoxate',
    metaDescription:
      'Octinoxate is a synthetic compound used in sunscreens to protect the skin against the damaging effect of UV radiation.',
  },
]
